export const getNonUSStdServicesOfAddendum = (formData, originalData) => {
  const saperateFormDataNonUsmarketplaces = (dataInfo) => {
    return (
      dataInfo?.length &&
      dataInfo
        .filter((item) => item.name === 'VAT Registration')
        .map((filteredItem) => filteredItem)
    );
  };
  const addedRemovedStandardServices = (data1, data2) => {
    return data1?.filter((item) => {
      return !data2.some((item1) => {
        return item?.marketplace === item1?.marketplace;
      });
    });
  };
  // 1. For VAT Registration
  const formDataNonUsmarketplaces =
    saperateFormDataNonUsmarketplaces(
      formData?.standard_non_us_services?.length &&
        formData?.standard_non_us_services,
    ) || [];

  const originalDataNonUsmarketplaces =
    saperateFormDataNonUsmarketplaces(
      originalData?.standard_non_us_services?.length &&
        originalData?.standard_non_us_services,
    ) || [];

  const uniqueNonUsServices = addedRemovedStandardServices(
    formDataNonUsmarketplaces,
    originalDataNonUsmarketplaces,
  );

  // 2. for Vat Filling

  const seperateVATFilingMarketplaces = (dataInfo) => {
    const marketplaces =
      dataInfo?.length &&
      dataInfo.filter(
        (item) =>
          item.name === 'VAT Filing' &&
          item.marketplace !== null &&
          item.frequency !== null,
      );

    const result = [];
    if (marketplaces?.length) {
      marketplaces.map((item) => {
        result.push(
          //  `${displayMarketplaceName(item.marketplace, 'vat', 'lhs')} (${
          //    item?.frequency
          //  })`,
          item,
        );
        return null;
      });
    }
    return result.length ? result : [];
  };

  const formDataVATFilingMarketplaces =
    seperateVATFilingMarketplaces(
      formData?.standard_non_us_services?.length &&
        formData?.standard_non_us_services,
    ) || [];

  const originalDataVATFilingMarketplaces =
    seperateVATFilingMarketplaces(
      originalData?.standard_non_us_services?.length &&
        originalData?.standard_non_us_services,
    ) || [];

  const addedVatFillingNonUsServices = addedRemovedStandardServices(
    formDataVATFilingMarketplaces,
    originalDataVATFilingMarketplaces,
  );

  // 3. for international service

  const seperateFormDataInternationalNonUsServices = (dataInfo) => {
    return (
      dataInfo?.length &&
      dataInfo.filter((item) => item?.name?.includes('International'))
    );
  };

  const uniqueInternationalNonUsServices = (data1, data2) =>
    data1?.filter((item) => {
      return !data2.some((item1) => {
        return item.name === item1.name;
      });
    });

  const formDataInternationalNonUsServices =
    seperateFormDataInternationalNonUsServices(
      formData?.standard_non_us_services?.length &&
        formData?.standard_non_us_services,
    ) || [];

  const originalDataInternationalNonUsServices =
    seperateFormDataInternationalNonUsServices(
      originalData?.standard_non_us_services?.length &&
        originalData?.standard_non_us_services,
    ) || [];

  const addedInternationalNonUsServices = uniqueInternationalNonUsServices(
    formDataInternationalNonUsServices,
    originalDataInternationalNonUsServices,
  );

  return {
    vatRegistration: uniqueNonUsServices,
    vatFilling: addedVatFillingNonUsServices,
    internationalService: addedInternationalNonUsServices,
  };
};

export const getUpdatedStrByReplacingChannelType = (strData, formData) => {
  const sellerField = formData?.fee_structure_seller_type;
  const vendorField = formData?.fee_structure_vendor_type;
  return strData
    ?.replaceAll('CHANNEL_TYPE', formData?.channel?.label)
    ?.replaceAll('SELLER_ACCOUNT_TYPE', sellerField)
    ?.replaceAll('VENDOR_ACCOUNT_TYPE', vendorField);
};

export const handleChange = (
  event,
  selectedService,
  updatedFormData,
  formData,
  setFormData,
  setUpdatedFormData,
  showFooter,
  contractAddendumDetails,
) => {
  showFooter(true);
  let showServiceInTable = [];
  if (formData?.standard_us_services?.length)
    showServiceInTable = [...formData?.standard_us_services];

  if (!event.target.checked) {
    // add the selected service in the delete array and remove the service from the agreement table (on LHS).
    const tempService = updatedFormData?.standard_us_services?.delete?.find(
      (ele) => ele === selectedService?.id,
    );
    if (!tempService) {
      let tempDeletedServices = [];
      if (updatedFormData?.standard_us_services?.delete) {
        tempDeletedServices = [...updatedFormData.standard_us_services?.delete];
      }
      showServiceInTable = formData?.standard_us_services?.filter(
        (op) => op.name !== event.target.name,
      );
      let createServices = updatedFormData?.standard_us_services?.create?.length
        ? [...updatedFormData?.standard_us_services?.create]
        : [];
      createServices = updatedFormData?.standard_us_services?.create?.filter(
        (op) => op.name !== event.target.name,
      );

      setFormData({
        ...formData,
        standard_us_services: showServiceInTable,
      });
      setUpdatedFormData({
        ...updatedFormData,
        standard_us_services: {
          create: createServices,
          delete: [...tempDeletedServices, selectedService?.id],
        },
      });
    }
  }
  if (event.target.checked) {
    let tempCreateServices = [];
    if (updatedFormData?.standard_us_services?.create) {
      tempCreateServices = [...updatedFormData.standard_us_services?.create];
    }

    // if selected service not in DB, add it in create array and show the service in agreement table (on LHS).
    if (!selectedService?.id) {
      const addendumData = {
        name: event.target.name,
        contract_addendum: formData?.id,
      };
      const contractData = {
        name: event.target.name,
        contract: formData?.id,
      };
      showServiceInTable.push(
        contractAddendumDetails?.notActive ? addendumData : contractData,
      );

      setFormData({
        ...formData,
        standard_us_services: showServiceInTable,
      });
      const createContractData = contractAddendumDetails?.notActive
        ? {
            name: event.target.name,
            contract_addendum: formData?.id,
          }
        : { name: event.target.name, contract: formData?.id };
      setUpdatedFormData({
        ...updatedFormData,
        standard_us_services: {
          ...updatedFormData.standard_us_services,
          create: [...tempCreateServices, createContractData],
        },
      });
    }
    // if selected service in DB, remove the selected ID from the delete array and from the agreement table (on LHS).
    if (selectedService?.id) {
      const contractData = {
        name: event?.target?.name,
        contract: formData?.id,
      };
      const addendumData = {
        name: event?.target?.name,
        contract_addendum: formData?.id,
      };
      showServiceInTable.push(
        contractAddendumDetails?.notActive ? addendumData : contractData,
      );
      setFormData({
        ...formData,
        standard_us_services: showServiceInTable,
      });
      const tempDeletedServices =
        updatedFormData.standard_us_services?.delete?.filter(
          (op) => op !== selectedService?.id,
        );
      setUpdatedFormData({
        ...updatedFormData,
        standard_us_services: {
          ...updatedFormData.standard_us_services,
          delete: tempDeletedServices,
        },
      });
    }
  }
};

/**
 * Utility function to add a standard service to formData and updatedFormData
 * @param {Object} params
 * @param {string} params.serviceName - Name of the service to add
 * @param {Object|null} params.existingService - Existing service from DB (with id) or null
 * @param {Object} params.updatedFormData - Current updatedFormData state
 * @param {Object} params.formData - Current formData state
 * @param {boolean} params.isAddendum - Whether this is an addendum
 * @returns {Object} - { nextUpdatedFormData, newServiceObject }
 */
export const getUpdatedFormDataForAddService = ({
  serviceName,
  existingService,
  updatedFormData,
  formData,
  isAddendum,
}) => {
  let nextUpdatedFormData = { ...updatedFormData };

  // Create service object with correct structure
  const newServiceObject = {
    name: serviceName,
    ...(isAddendum
      ? { contract_addendum: formData?.id }
      : { contract: formData?.id }),
    ...(existingService?.id ? { id: existingService.id } : {}),
  };

  if (!existingService?.id) {
    // Service doesn't exist in DB, add to create array
    const createService = {
      name: serviceName,
      ...(isAddendum
        ? { contract_addendum: formData?.id }
        : { contract: formData?.id }),
    };

    const existingCreateServices =
      nextUpdatedFormData?.standard_us_services?.create || [];

    // Check if service is not already in create array
    const isAlreadyInCreate = existingCreateServices.some(
      (srv) => srv.name === serviceName,
    );

    if (!isAlreadyInCreate) {
      nextUpdatedFormData = {
        ...nextUpdatedFormData,
        standard_us_services: {
          ...nextUpdatedFormData.standard_us_services,
          create: [...existingCreateServices, createService],
        },
      };
    }
  } else {
    // Service exists in DB, remove from delete array if present
    const existingDeleteServices =
      nextUpdatedFormData?.standard_us_services?.delete || [];
    const filteredDeleteServices = existingDeleteServices.filter(
      (id) => id !== existingService.id,
    );

    nextUpdatedFormData = {
      ...nextUpdatedFormData,
      standard_us_services: {
        ...nextUpdatedFormData.standard_us_services,
        delete: filteredDeleteServices,
      },
    };
  }

  return { nextUpdatedFormData, newServiceObject };
};
